import React from 'react';
import { Col, Grid, Row } from 'antd';
import ImageC from 'src/components/Image';
import cn from "src/utils/cn";

type Props = {
	className?: string;
	title: string;
	image: string;
	contactUrl: string;
};

const Contact = (props: Props) => {
	const { md, xl } = Grid.useBreakpoint();

	return (
		<div className={cn(props.className, 'container')}>
			<Row align="middle">
				{md && (
					<Col xs={24} md={12}>
						<h2 className="mb-8 text-5xl font-bold max-xl:text-2xl max-xs:my-6 max-xs:mt-6 max-xs:mb-4 max-xs:text-center max-xs:text-xl max-xs:font-semibold max-xs:leading-7">
							<span
								dangerouslySetInnerHTML={{
									__html: props.title,
								}}
							/>
						</h2>
						<Col
							className="mt-4 py-3 rounded-full border border-black text-center"
							xs={14}
							xl={12}
						>
							<a
								className="text-base font-bold text-neutral max-xl:text-sm"
								href={props.contactUrl}
							>
								Cek Sekarang!
							</a>
						</Col>
					</Col>
				)}

				<Col className="flex flex-col items-center" xs={24} md={12}>
					<div>
						<ImageC
							className="rounded-lg"
							width={xl ? 550 : 413}
							height={xl ? 275 : 207}
							src={props.image}
							style={{ objectFit: 'cover' }}
						/>
					</div>

					{!md && (
						<>
							<h2 className="mb-8 text-5xl font-bold max-xl:text-2xl max-xs:my-6 max-xs:mt-6 max-xs:mb-4 max-xs:text-center max-xs:text-xl max-xs:font-semibold max-xs:leading-7">
								<span
									dangerouslySetInnerHTML={{
										__html: props.title,
									}}
								/>
							</h2>
							<Col
								className="w-full mt-4 py-3 rounded-full border border-black text-center"
								xs={14}
								xl={12}
							>
								<a
									className="text-base font-bold text-neutral max-xl:text-sm"
									href={props.contactUrl}
								>
									Cek Sekarang!
								</a>
							</Col>
						</>
					)}
				</Col>
			</Row>
		</div>
	);
};

export default Contact;
